export * from "./ic-bg-home-page";
export * from "./ic-bot-sparkle";
export * from "./ic-delete-warnning";
export * from "./ic-flag-ar";
export * from "./ic-flag-eng";
export * from "./ic-flag-vi";
export * from "./ic-flash-on";
export * from "./ic-globe-shield";
export * from "./ic-group-members";
export * from "./ic-not-found-page";
export * from "./ic-oxu-logo";
export * from "./ic-people";
export * from "./ic-sidebar-account-management-active";
export * from "./ic-sidebar-account-management";
export * from "./ic-sidebar-group-management-active";
export * from "./ic-sidebar-group-management";
export * from "./ic-sidebar-home-active";
export * from "./ic-sidebar-home";
export * from "./ic-sidebar-role-management-active";
export * from "./ic-sidebar-role-management";
export * from "./ic-success-logo";
export * from "./ic-search";
export * from "./ic-document";
export * from "./ic-image";
export * from "./ic-ai";
export * from "./ic-glass-personal";
export * from "./ic-glass-business";
export * from "./ic-pdf";
export * from "./ic-send-email";
export * from "./ic-csv";
export * from "./ic-xlsx";
export * from "./ic-xls";
